import { formatMrqNumbersFromTask } from "../../../../../AllEquipments/CommonFeatures/MCS3/Schedule4D/scheduleTaskApi";
import { parseTaskCode } from "./taskCodeUtils";

export const normalizeDescription = (str) => {
  if (str == null || str === "") return "";

  return String(str)
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\s*,\s*/g, ", ");
};

export const toDateStr = (v) => {
  if (!v) return "";
  return typeof v === "string" ? v.slice(0, 10) : "";
};

export const formatTasksFor4D = (tasks) => {
  if (!Array.isArray(tasks)) return [];

  const normalizeDate = (value) => {
    if (!value) return null;
    return value;
  };

  return tasks
    .filter((taskItem) => !taskItem.isArchieved)
    .map((taskItem) => {
      const rawProgress = taskItem.progress ?? 0;
      const progress = Number.isNaN(Number(rawProgress))
        ? 0
        : Number(rawProgress);

      const estimatedTime =
        taskItem.estimatedTime != null
          ? Number(taskItem.estimatedTime)
          : taskItem.manhours != null
            ? Number(taskItem.manhours)
            : 0;

      const hours = taskItem.hours != null ? Number(taskItem.hours) : null;

      return {
        ...taskItem,
        id: taskItem.id,
        taskCode: taskItem.taskCode || "",
        name: taskItem.name || null,
        task: taskItem.task || null,
        type: (taskItem.type || "").toLowerCase(),
        progress,
        startDate: normalizeDate(taskItem.startDate),
        endDate: normalizeDate(taskItem.endDate || taskItem.targetDate),
        revisedStart: normalizeDate(
          taskItem.revisedStart || taskItem.revisedStartDate
        ),
        revisedEnd: normalizeDate(
          taskItem.revisedEnd || taskItem.revisedEndDate
        ),
        actualStart: normalizeDate(taskItem.actualStart),
        actualEnd: normalizeDate(taskItem.actualEnd),
        estimatedTime,
        manhours: taskItem.manhours != null ? Number(taskItem.manhours) : null,
        hours,
        mrqMaterials: taskItem.mrqMaterials,
        mrvMaterials: taskItem.mrvMaterials,
        priority: taskItem.priority || "",
        status: taskItem.status || "",
        comments: Array.isArray(taskItem.comments) ? taskItem.comments : [],
        attachment: taskItem.attachment || "",
        task_members: Array.isArray(taskItem.task_members)
          ? taskItem.task_members
          : taskItem.task_members
            ? [taskItem.task_members]
            : [],
        resourceId:
          taskItem.resourceId ??
          taskItem.resource?.id ??
          null,
        resource: taskItem.resource ?? null,
        targetDate: normalizeDate(taskItem.targetDate || taskItem.endDate),
        isArchived: !!(taskItem.isArchived || taskItem.isArchieved),
      };
    })
    .filter((task) => task.taskCode);
};

export const buildRowsFromTasksForEditableTable = (tasks) => {
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return [];
  }

  const formattedTasks = formatTasksFor4D(tasks);

  if (formattedTasks.length === 0) {
    return [];
  }

  const rowsForTable = formattedTasks.map((task) => {
    const type = (task.type || "").toLowerCase();
    const progressValue = Number.isNaN(Number(task.progress))
      ? 0
      : Number(task.progress);

    let fourD = "";
    if (type === "engineering") fourD = "DCS";
    else if (type === "procurement") fourD = "MCS";
    else if (type === "fabrication") fourD = "PCS";
    else if (type === "itp") fourD = "ITP";

    const { code: displayCode } = parseTaskCode(task.taskCode || "");
    const mrqNumber = formatMrqNumbersFromTask(task);

    return {
      ...task,
      id: task.id,
      uid: parseTaskCode(task.taskCode || "").uid || task.uid || "",
      task: task.task || task.name || "",
      name: task.task || task.name || "",
      type: task.type || null,
      taskCode: task.taskCode,
      fourD,
      wbsId: displayCode || task.taskCode || "",
      mrqNumber,
      progress: progressValue,
      plannedStart: toDateStr(task.startDate),
      plannedEnd: toDateStr(task.endDate),
      revisedStart: toDateStr(task.revisedStart),
      revisedEnd: toDateStr(task.revisedEnd),
      actualStart: toDateStr(task.actualStart),
      actualEnd: toDateStr(task.actualEnd),
      budgetedHrDollar: task.estimatedTime || 0,
      actualHrDollar: task.manhours ?? 0,
      hours: task.hours ?? task.manhours ?? 0,
      targetDate: toDateStr(task.targetDate || task.endDate),
      isArchived: !!task.isArchived,
      priority: task.priority || "",
      status: task.status || "",
      comments: Array.isArray(task.comments) ? task.comments : [],
      attachment: task.attachment || "",
      task_members: Array.isArray(task.task_members) ? task.task_members : [],
      resourceId: task.resourceId ?? task.resource?.id ?? null,
      resource: task.resource ?? null,
    };
  });

  return rowsForTable.sort((a, b) => {
    const dateA = a.plannedStart ? new Date(a.plannedStart) : new Date(0);
    const dateB = b.plannedStart ? new Date(b.plannedStart) : new Date(0);

    return dateA - dateB;
  });
};
